import { Component, Input } from '@angular/core';
import { HealthStatus } from '../../core/services/cloud.service';

@Component({
  selector: 'app-status-badge',
  template: `
    <span class="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold" [class]="badgeClass">
      <span class="h-1.5 w-1.5 rounded-full" [class]="dotClass"></span>{{ label }}
    </span>
  `,
})
export class StatusBadgeComponent {
  @Input() status: HealthStatus = 'unknown';

  get label(): string {
    return { healthy: 'Healthy', warning: 'Warning', critical: 'Critical', unknown: 'Unknown', idle: 'Idle' }[this.status];
  }
  get badgeClass(): string {
    return { healthy: 'bg-emerald-100 text-emerald-700', warning: 'bg-amber-100 text-amber-700', critical: 'bg-red-100 text-red-700', unknown: 'bg-slate-100 text-slate-500', idle: 'bg-sky-50 text-sky-700' }[this.status];
  }
  get dotClass(): string {
    return { healthy: 'bg-emerald-500', warning: 'bg-amber-500', critical: 'bg-red-500', unknown: 'bg-slate-400', idle: 'bg-sky-400' }[this.status];
  }
}
